import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PlanningTypeLayer from "../components/PlanningTypeLayer";


const PlanningTypePage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout pageTitle="Asset Type">

        {/* UsersListLayer */}
        <PlanningTypeLayer />

      </MasterLayout>

    </>
  );
};

export default PlanningTypePage; 